import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const ORDER_ACCESSORY_DELIVERY_STATES = [
  'pending',
  'submited',
  'received',
  'rejected',
  'confirmed',
]

const entityColumns = {
  id: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'id',
    label_key_path: 'orderAccessoryDelivery.id',
  },
  created_at: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'datetime',
    label_key_path: 'orderAccessoryDelivery.createdAt',
  },
  updated_at: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'datetime',
    label_key_path: 'orderAccessoryDelivery.updatedAt',
  },
  order: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'belongs_to',
    label_key_path: 'orderAccessoryDelivery.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_id: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'belongs_to',
    label_key_path: 'orderAccessoryDelivery.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  state: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'enum',
    extra: {
      options: ['pending', 'submited', 'received', 'rejected', 'confirmed'],
    },
    label_key_path: 'orderAccessoryDelivery.state',
  },
  number: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'integer',
    label_key_path: 'orderAccessoryDelivery.number',
  },
  accessories: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'has_many',
    label_key_path: 'orderAccessoryDelivery.accessories',
    extra: {
      association_name: 'accessories',
      model_name: 'Accessory',
      foreign_key: 'accessory_id',
      display_column: 'name',
    },
  },
  accessory_ids: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'has_many',
    label_key_path: 'orderAccessoryDelivery.accessories',
    extra: {
      association_name: 'accessories',
      model_name: 'Accessory',
      foreign_key: 'accessory_id',
      display_column: 'name',
    },
  },
  order_accessory_delivery_items: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'has_many',
    label_key_path: 'orderAccessoryDelivery.orderAccessoryDeliveryItems',
    extra: {
      association_name: 'order_accessory_delivery_items',
      model_name: 'OrderAccessoryDeliveryItem',
      foreign_key: 'order_accessory_delivery_id',
      display_column: 'id',
    },
  },
  order_accessory_delivery_item_ids: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'has_many',
    label_key_path: 'orderAccessoryDelivery.orderAccessoryDeliveryItems',
    extra: {
      association_name: 'order_accessory_delivery_items',
      model_name: 'OrderAccessoryDeliveryItem',
      foreign_key: 'order_accessory_delivery_id',
      display_column: 'id',
    },
  },
  operation_logs: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'has_many',
    label_key_path: 'orderAccessoryDelivery.operationLogs',
    extra: {
      association_name: 'operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  operation_log_ids: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'has_many',
    label_key_path: 'orderAccessoryDelivery.operationLogs',
    extra: {
      association_name: 'operation_logs',
      model_name: 'OperationLog',
      foreign_key: 'target_id',
      display_column: 'id',
    },
  },
  abilities: {
    model_name: 'OrderAccessoryDelivery',
    column_type: 'string',
    label_key_path: 'orderAccessoryDelivery.abilities',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
